var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showEnvNotice)?_c('div',{class:['envNotice', _vm.environment]},[_c('div',{staticClass:"env"},[_vm._v(_vm._s(_vm.environment == 'dev' ? 'DEV' : 'VorProd'))]),_c('div',{staticClass:"version"},[_vm._v("MWB v"+_vm._s(_vm.appVersion)),(_vm.apiVersion)?[_vm._v(" | MWB-API v"+_vm._s(_vm.apiVersion))]:_vm._e()],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }